import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

const RootDiv = styled('div')({
  border: '1px solid #EAEAEA',
  backgroundColor: 'white',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: '12px 15px',
  borderRadius: '10px',
  marginTop: '20px',
});

const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#333333',
  marginBottom: '12px',
  textAlign: 'left',
});

const DivisionLine = styled('div')({
  height: '1px',
  backgroundColor: '#EAEAEA',
  marginBottom: '12px',
  width: 'calc(100% + 30px)',
  marginLeft: '-15px',
});

const InfoContainerDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
});

const InfoContainerItem = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  marginBottom: '12px',
  marginLeft: '5px',
});

const InfoContainerItemImg = styled('img')({
  width: '21px',
  display: 'block',
  marginRight: '15px',
});

const InfoContainerItemText = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#757475',
});

export {
  RootDiv,
  TitleTypography,
  DivisionLine,
  InfoContainerDiv,
  InfoContainerItem,
  InfoContainerItemImg,
  InfoContainerItemText,
};
